module.exports = __webpack_public_path__ + "img/popular-title.44ab2638.png";